export const CRM_URL_OPT_IN = 'https://pub.s7.exacttarget.com/5ir2zowajhd?uid=';
export const CRM_URL_OPT_OUT = 'https://mc0b-2bdcfl28v65rv9nl3hy9dpy.pub.sfmc-content.com/hbxb51jd0jk?uid=';
export const REACTIVATION_SERVICE_URL = 'enableAutoRenewalFromTokenWithOptIn';
